export const GENDER_FEMALE = '1';
export const GENDER_MALE = '2';

export const GENDERS = [GENDER_FEMALE, GENDER_MALE];
